import PropTypes from 'prop-types';
import React from 'react';
import { FormattedRelative, FormattedDate } from 'react-intl';
import {isFinite} from 'lodash';

export default function CardPublishDate(props, context) {
  const { timestamp, timeZone } = props;
  const { location } = context;
  const now = isFinite(location.query.initialNow)
    ? location.query.initialNow
    : Date.now();
  const oneDayAgo = now - (1000 * 60 * 60 * 24);

  if (timestamp > oneDayAgo) {
    return <FormattedRelative value={timestamp} />;
  }

  return (
    <FormattedDate value={timestamp}
      year="numeric"
      month="short"
      day="numeric"
      timeZone={timeZone}
    />
  );
}

CardPublishDate.propTypes = {
  timestamp: PropTypes.number.isRequired,
  timeZone: PropTypes.string
};

CardPublishDate.contextTypes = {
  location: PropTypes.object
};
